import _ from 'lodash';
import { PaymentLinkActionType } from './actions';
import { errorFieldsCode, invalidCountryCode, invalidDocumentCode, invalidMinimumAmount } from '../../utils/error-codes';
import { handleErrorInfo } from '../../utils/index';
import { PaymentLinkState } from './interfaces';
import { Currencies, DocumentTypes, ErrorFields } from '../interfaces';

const initialState: PaymentLinkState = {
  loading: false,
  error: false,
  errorInfo: undefined,
  errorFields: undefined,
  createSuccess: null,
  showResult: false,
  currencies: {},
  documentTypes: {},
  created: {
    loading: false,
    error: false,
    errorInfo: undefined,
    allPaymentLinks: undefined,
  },
  existingClients: {
    loading: false,
    error: false,
    errorInfo: undefined,
    clients: undefined,
  },
};

const PaymentLinkReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PaymentLinkActionType.INIT_PAYMENT_LINK: {
      return {
        ...state,
        error: false,
        errorInfo: undefined,
        currencies: {},
        documentTypes: {},
      };
    }
    case PaymentLinkActionType.CLEAN_ERROR_PAYMENT_LINK: {
      return {
        ...state,
        error: false,
        errorInfo: undefined,
      };
    }
    case PaymentLinkActionType.GET_CURRENCIES: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
        currencies: {},
      };
    }
    case PaymentLinkActionType.GET_CURRENCIES_SUCCESS: {
      const currencies: Currencies = {};
      action.response.forEach((c: any) => {
        currencies[c.currency] = c.currency;
      });
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
        currencies,
      };
    }
    case PaymentLinkActionType.GET_CURRENCIES_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(PaymentLinkActionType.GET_CURRENCIES_ERROR, action.error),
        currencies: {},
      };
    }
    case PaymentLinkActionType.PAYMENT_LINK_RESULT: {
      return {
        ...state,
        ...(action.show
          ? { showResult: true, createSuccess: state.createSuccess }
          : {
              showResult: false,
              createSuccess: null,
              currencies: {},
              documentTypes: {},
            }),
      };
    }
    case PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
        documentTypes: {},
      };
    }
    case PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_SUCCESS: {
      const documentTypes: DocumentTypes = {};
      action.response.forEach((dt: any) => {
        documentTypes[dt.documentType] = dt.documentType;
      });
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
        documentTypes,
      };
    }
    case PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(PaymentLinkActionType.GET_DOCUMENT_TYPES_FOR_PAYMENT_LINK_ERROR, action.error),
        documentTypes: {},
      };
    }
    case PaymentLinkActionType.CREATE_PAYMENT_LINK: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
        errorFields: undefined,
        createSuccess: null,
      };
    }
    case PaymentLinkActionType.CREATE_PAYMENT_LINK_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
        createSuccess: {
          ...action.response,
        },
      };
    }
    case PaymentLinkActionType.CREATE_PAYMENT_LINK_ERROR: {
      let errorInfo = handleErrorInfo(PaymentLinkActionType.CREATE_PAYMENT_LINK_ERROR, action.error);
      const errorFields: ErrorFields = {};
      let error = true;

      if (errorInfo && errorInfo.code === errorFieldsCode && errorInfo.errorFields) {
        errorInfo.errorFields.forEach((field: string) => {
          errorFields[field] = action.error.sentValues[field];
        });
        error = false;
        errorInfo = undefined;
      } else if (errorInfo && errorInfo.code === invalidDocumentCode) {
        errorFields.clientDocument = action.error.sentValues.clientDocument;
      } else if (errorInfo && errorInfo.code === invalidCountryCode) {
        errorFields.country = action.error.sentValues.country;
      } else if (errorInfo && errorInfo.code === invalidMinimumAmount) {
        errorFields.amount = action.error.sentValues.amount;
      }

      return {
        ...state,
        loading: false,
        error,
        errorInfo,
        errorFields,
        createSuccess: undefined,
      };
    }
    case PaymentLinkActionType.GET_EXISTING_CLIENTS: {
      return {
        ...state,
        existingClients: {
          ...state.existingClients,
          loading: true,
          error: false,
          errorInfo: undefined,
        },
      };
    }
    case PaymentLinkActionType.GET_EXISTING_CLIENTS_SUCCESS: {
      return {
        ...state,
        existingClients: {
          ...state.existingClients,
          loading: false,
          clients: {
            ...action.response,
          },
        },
      };
    }
    case PaymentLinkActionType.GET_EXISTING_CLIENTS_ERROR: {
      return {
        ...state,
        existingClients: {
          ...state.existingClients,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(PaymentLinkActionType.GET_EXISTING_CLIENTS_ERROR, action.error),
          clients: undefined,
        },
      };
    }
    case PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS: {
      return {
        ...state,
        created: {
          ...state.created,
          loading: true,
          error: false,
          errorInfo: undefined,
        },
      };
    }
    case PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS_SUCCESS: {
      return {
        ...state,
        created: {
          ...state.created,
          loading: false,
          allPaymentLinks: {
            ...action.response,
          },
        },
      };
    }
    case PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS_ERROR: {
      return {
        ...state,
        created: {
          ...state.created,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(PaymentLinkActionType.GET_CREATED_PAYMENT_LINKS_ERROR, action.error),
          allPaymentLinks: null,
        },
      };
    }
    default:
      return state;
  }
};

export default PaymentLinkReducer;
